import wcmatch from "wildcard-match";

export const canView = (permission: string, permissions: string[]) => {
  const isMatch = wcmatch(permissions, { separator: ":" });
  return permissions[0] === "**" ? true : isMatch(permission);
};
